import React, { Fragment }from 'react';
import {Outlet} from 'react-router-dom';
import '../TeamMembers/TeamMemberByOneBy.css';
import pht from '../imageproje/107-1/00.avif'
import CardMedia from '@mui/material/CardMedia';
import teamMemberPhoto from '../imageproje/TeamImage/senolKayrak.avif';
import { Container, Grid, Typography } from '@mui/material';
import Comunication from '../components/Comunication';
import ComunicationPhone from '../components/ComunicationPhone';
import ComunicationEmail from '../components/ComunicationEmail';
import YouTubeIcon from '@mui/icons-material/YouTube';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PhoneIcon from '@mui/icons-material/Phone';
import MailOutlineIcon from '@mui/icons-material/MailOutline';


function SelcukTopcu() {
  return (
    <Fragment>
    <Comunication/>
    <ComunicationPhone/>
    <ComunicationEmail/>
    <Container style={{marginTop:100, padding:0}}>
      
      <CardMedia 
      sx={{width:'100%'}}
      image={pht}>
      <p className='writingPosition'>Şenol Kayrak</p>
      </CardMedia>
      
    </Container>
    <Container>
      <Grid className='teamMemberDeatilInfo' sx={{display:'flex'}}>
        <Grid size={6}>
          <img className='teamMember-Photo' src={teamMemberPhoto} style={{width:350,height:'auto'}} alt="" />
        </Grid>
        <Grid size={6} sx={{marginLeft:5}}>
          <Typography variant='body1' component='p'><br />
            Şenol Kayrak, 2023 yılından bu yana tavizsiz dürüstlük ve profesyonellikle Emlakçın'daki gayrimenkulleri satıyor.
            <br />
            <br />
          </Typography>
          <Typography variant='body1' component='p'>
            Çatalca'da doğdu. İlk, orta ve lise öğrenimini ilçede tamamladı.
            <br />
            <br />
          </Typography>
          <Typography variant='body1' component='p'>
            Seyahat tutkusuyla ülkede çok yerler gezdi ve yaşadı. 
            2023 yazında doğduğu yerleri ziyaret ederken, buranın onun gerçek evi olarak adlandırmaya zorlayan gerçek ve elle tutulur bir yer duygusu deneyimledi.
            <br />
            <br />
            2023'ten beri bölgede yaşıyor ve Istıranca Ormanların'da uzun yürüyüşler, kırsal kayak, kaya tırmanışı ve bisiklet gibi aktif bir yaşam tarzının tadını çıkarıyor. 
            Boş zamanlarında ülkeyi keşfetmeye devam ediyor ve ailes bireylerini ziyaret etmek için sık sık ülke genelinde seyahat ediyor.
            <br />
            <br />
          </Typography> 
        </Grid>
      </Grid>
        <Grid size={12}>
          
        </Grid>
      <Grid>
      </Grid>   
      <br></br>
      </Container>
      <Container className='teamMember-Personel-Info' sx={{marginBottom:5}} >
        <Grid className='teamMemberSocialMedia' sx={{display:'flex'}} gap={2}>
          <Grid  size={2}>
            <a href="https://www.youtube.com/@emlakcinn" className='teamMenberOneByOne'><YouTubeIcon/></a>
          </Grid>
          <Grid size={2}  >
            <a href="https://www.facebook.com/share/1BBqDbdAdU/?mibextid=LQQJ4d" className='teamMenberOneByOne'><FacebookIcon/></a>
          </Grid>
          <Grid size={2}  >
            <a href="https://www.instagram.com/emlakcinn" className='teamMenberOneByOne'><InstagramIcon/></a>
          </Grid>
          <Grid size={2}>
            <a href="https://x.com/emlakcinn" className='teamMenberOneByOne'><TwitterIcon/></a>
          </Grid>
          <Grid size={2}>
            <a href="https://api.whatsapp.com/send?phone=905360179017"className='teamMenberOneByOne'><WhatsAppIcon/></a>
          </Grid>
          <Grid size={2}>
            <a href="tel:+905360179017"className='teamMenberOneByOne'><PhoneIcon/></a>
          </Grid>
          <Grid size={2}>
            <a href="mailto:info@emlakcinn.com"className='teamMenberOneByOne'><MailOutlineIcon/></a>
          </Grid>
        </Grid>
      </Container>
      <Container className='teamMember-Personel-Info' sx={{backgroundColor:'rgb(241, 241, 241)',marginBottom:5,padding:3}}>
        <Grid>
          <Grid size={12}>
            <Typography variant='h5' component='h5'><i>Şenol Kayrak</i></Typography>
          </Grid>
          <Grid size={12}>
          <Typography variant='h5' component='h5' className='realEstateInfo' >Emlak Danışmanı</Typography>
          <br />
          </Grid>
        </Grid>
        <Grid sx={{display:'flex'}} gap={15}>
          <Grid size={4}>
          <Typography>Telefon</Typography>
            <Typography>
              0 536 017 90 17
            </Typography>
          </Grid>
          <Grid size={4}>
            <Typography>Email</Typography>
            <Typography>
              info@emlakcinn.com
            </Typography>
          </Grid>
          <Grid size={4}>
            <Typography>Adres</Typography>
            <Typography>
              Cebeci Mah, 2457 Sok, No: 23/B Sultangazi / İstanbul
            </Typography>
          </Grid>
        </Grid>
      </Container>
      <Outlet/>
  </Fragment>
  )
}

export default SelcukTopcu;